import { isNull } from "lodash";
import React, { useEffect } from "react";

import { IDataItem } from "../types";
import { EditButton, RemoveItem, SubmitCancelButtons } from "./actions";
import css from "./row_actions.module.scss";

interface IProps {
  cellData: IDataItem;
  setKeyToRemove: (key: string) => void;
  setConfirmRemove: (boolean) => void;
  setEditedRowKey: (string) => void;
  isEditMode: boolean;
  setData: (prev: any) => void;
  submitThreshold: (IDataItem) => void;
  setEditedColorItem: (any) => void;
  setErrorKey: (any) => void;
}

const RowActions = ({
  cellData,
  setKeyToRemove,
  setConfirmRemove,
  setEditedRowKey,
  isEditMode,
  setData,
  submitThreshold,
  setEditedColorItem,
  setErrorKey
}: IProps) => {
  useEffect(() => {
    const isNew = isNull(cellData.max) && isNull(cellData.min);
    if (isNew) {
      setEditedRowKey(cellData.key);
    }
  }, [cellData]);

  return (
    <div className={css.wrapper}>
      {isEditMode ? (
        <SubmitCancelButtons
          cancelEdit={() => {
            setEditedRowKey(null);
            setEditedColorItem(null);
            setErrorKey(null);
            setData((prev) => prev.filter((item) => !item.new));
          }}
          submitEdit={() => submitThreshold(cellData)}
        />
      ) : (
        <EditButton setEditMode={() => setEditedRowKey(cellData.key)} />
      )}
      {!isEditMode && (
        <RemoveItem
          keyToRemove={cellData.key}
          removeItem={(key) => {
            setKeyToRemove(key);
            setConfirmRemove(true);
            setEditedColorItem(null);
          }}
        />
      )}
    </div>
  );
};

export default RowActions;
